export default __webpack_public_path__ + "static/media/POOP.1415854f.png";